import PageLoading from './PageLoading';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Banner } from '@shopify/polaris';
import { API_DOMAIN } from '../utils/constants';
import { syncUserTokenFromSearch } from '../utils/userToken';
import { prepareAdminEntry } from '../utils/adminEntry';

export default function AdminEntry({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    try {
      let storage;
      try { storage = window.sessionStorage; } catch (_) { /* Optional. */ }
      const result = prepareAdminEntry({ location, token: syncUserTokenFromSearch(location.search), apiDomain: API_DOMAIN, storage });
      if (result.redirect) { window.location.replace(result.redirect); return; }
      if (result.restore) navigate(result.restore, { replace: true });
      setReady(true);
    } catch (e) { setError(e.message); }
  }, [location, navigate]);
  if (error) return <Banner tone="critical">{error}</Banner>;
  if (!ready) return <PageLoading label="Opening NinaCheck" message="Opening NinaCheck…" />;
  return children;
}
